<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout column>

    <v-tabs v-model="viewMode" centered @change="updateSearchListItems()">
      <v-tab>Alphabetisch</v-tab>
      <v-tab>Gruppiert</v-tab>
      <v-tab>Suche</v-tab>
    </v-tabs>
    <v-flex v-if="viewMode != 2">
      <v-treeview :items="searchItems" :active.sync="selected" activatable open-on-click ref="searchItemTree" 
        :style="{ overflow: 'auto', 'max-height': containerHeight-56+'px' }">
        <template v-slot:label="{ item, leaf }">
          <div v-if="item.toplevel" class="subheading">{{ item.title }}</div>
          <div v-if="!leaf && !item.toplevel">{{ item.title }}</div>
          <div v-if="leaf" @dragstart="startDrag($event, item)" draggable class="pointer bluetext">{{ item.title }}</div>
        </template>
      </v-treeview>
    </v-flex>
    <v-flex v-if="viewMode == 2">
      <v-text-field v-model="searchItemsQuery" :clearable="true" label="Suchbegriff" class="pa-2 ma-2" hide-details height="30px" @keyup="onKeyUp">
        <template v-slot:append-outer >
          <v-btn outline class="text-none pa-0 ma-0" color="#004884" @click="updateSearchListItems()" small>Suchen</v-btn>
        </template>
      </v-text-field>
      <v-list dense :style="{ overflow: 'auto', 'max-height': listHeight }">
        <v-list-tile v-for="item in searchItems" :key="item.id" @click="onSelectItem(item.id)">
          <v-list-tile-content class="pointer" >{{ item.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: "SearchItemManager",
    props: [ 'currentMask', 'refFilterId', 'eventNewFilter', 'defaultTab', 'itemType', 'containerHeight' ],
    watch: {
      selected: function(val) {
        if (val.length == 0 || !this.eventNewFilter) {
          return;
        }
        Vue.prototype.$api.debug("selection changed", val);
        Vue.prototype.$eventHub.$emit(this.eventNewFilter, 'add', val[0], this.refFilterId);
        this.selected = [];
      },
      containerHeight: function (val) {
        Vue.prototype.$api.debug("Watcher containerHeight changed to " + val);
        this.onResize();
      },
    },
    data() {
      return {
        current: [],
        selectable: [],
        selected: [],
        searchItems: [],
        searchItemsQuery: '',
        viewMode: 0,
        listHeight: 100,
      };
    },
    methods: {
      startDrag(event, data) {
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('itemData', data.id);
        event.dataTransfer.setData('itemAction', 'add');
      },
      onResize () {
        Vue.prototype.$api.debug('SIM resize to ' + this.$props.containerHeight);

        if (this.$props.containerHeight) {
          this.listHeight = (this.$props.containerHeight - 40) + 'px';
        }
      },
      onKeyUp: function (evt) {
        if (evt.code === 'Enter') {
          this.updateSearchListItems();
          return;
        }
        if (evt.keyCode === 13) {
          this.updateSearchListItems();
          return;
        }
      },
      onSelectItem: function (itemid) {
        Vue.prototype.$eventHub.$emit(this.eventNewFilter, 'add', itemid, undefined, undefined);
      },
      updateSearchListItems () {
        var cmp = this;
        if (this.viewMode == 2) {
          cmp.searchItems = [];
          if (this.searchItemsQuery.length < 3) return;
          Vue.prototype.$api.getSearchMaskItems('', this.itemType, this.searchItemsQuery, function (data) {
            cmp.searchItems = data;
            cmp.searchItems.forEach(element => {
              element.toplevel = true;            
            });
          });
          return;
        }
        Vue.prototype.$api.getSearchMaskItems(this.viewMode == 0 ? 'alpha' : 'grouping' , this.itemType, '', function (data) {
          Vue.prototype.$api.debug('getSearchMaskItems returned:', cmp.viewMode, data);
          cmp.searchItems = data;
          cmp.searchItems.forEach(element => {
            element.toplevel = true;            
          });
          cmp.$nextTick(function () {
              cmp.$refs.searchItemTree.updateAll(this.viewMode == 0 ? true : false);
          });
        });
      }
    },
    created() {
      Vue.prototype.$api.debug('SearchItemManager created');
      // Vue.prototype.$eventHub.$on('onSearchParamChanged', this.onSearchParamChanged);
      window.addEventListener("resize", this.onResize);
    },
    destroyed() {
      Vue.prototype.$api.debug('SearchItemManager destroyed');
      // Vue.prototype.$eventHub.$off('onSearchParamChanged', this.onSearchParamChanged);
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      Vue.prototype.$api.debug('SearchItemManager mounted', { containerHeight: this.$props.containerHeight });
      if (this.$props.defaultTab == 'groups') {
        this.viewMode = 1;
      }
      for (let i in this.$props.currentMask) {
        this.current[this.$props.currentMask[i].filterId] = 1;
      }
      this.updateSearchListItems();
    }
  }
</script>

<style>
.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 32px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/module/mask/SearchItemManager.vue